module.exports = "\n#ConnectMiniModal {\n    overflow-y: hidden;\n}\n\n#ConnectMiniModal .modal-content {\n    max-height: 90vh;\n    min-height: 60vh;\n    overflow-y: auto !important;\n}\n\n#ConnectMiniModal .modal-content {\n     max-height: 90vh;\n     min-height: 60vh;\n     overflow-y: auto !important;\n}\n\n#ConnectMiniModal .modal-body {\n  max-height: 90vh;\n  min-height: 60vh;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/connect-mini-profile/connect-mini-profile.component.css
// module id = ./src/app/shared/components/connect-mini-profile/connect-mini-profile.component.css
// module chunks = main